import { useEffect } from 'react';

import { PageContainer } from '~/components/Page/Page.Container';
import type { ScreenPropPendingSupportRequests } from '~/navigation/Navigation.types';
import { SupportRequestItem } from '../SupportRequestItem';
import { SupportRequestsList } from './Flipper-SupportRequestsPending/Flipper.SupportRequestPending.List';
import { useSupportRequestStore } from '../utils/supportRequest.store';
import { View } from '@droplet-tech-code/core-elements/module/ui/View';
import { HStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { Divider } from '@droplet-tech-code/core-elements/module/ui/Divider/Divider';
import { getScreenWidth } from '@droplet-tech-code/core-elements/module/utils/utils.ui';
import { socketProvider } from '~/utils/socketProvider';
import { PendingSupportRequestsLayout as OldLayout } from './SupportRequestsPending.Screen.native';
import { useGetAuthUser } from '~/screens/Auth/Auth.Context';
import { SupportRequestSocketResponse } from './Flipper-SupportRequestsPending/SupportRequestSocket';

const PendingSupportRequestsScreen = (props: ScreenPropPendingSupportRequests) => {
  const setIsFromNew = useSupportRequestStore((state) => state.setIsFromNew);
  setIsFromNew(true);

  return (
    <PageContainer>
      <PendingSupportRequestsLayout {...props} />
    </PageContainer>
  );
};

export const PendingSupportRequestsScreenOld = (
  props: ScreenPropPendingSupportRequests,
) => {
  const setIsFromNew = useSupportRequestStore((state) => state.setIsFromNew);
  setIsFromNew(false);

  return (
    <PageContainer>
      <OldLayout {...props} />
    </PageContainer>
  );
};

export const PendingSupportRequestsLayout = (props: ScreenPropPendingSupportRequests) => {
  const supportRequestId = props.route.params?.id;
  const userId = useGetAuthUser().currentUser?.uid;
  const socket = socketProvider.getSocket();

  const id = useSupportRequestStore((state) => state.selectedRequestId);
  const setId = useSupportRequestStore((state) => state.setSelectedRequestId);

  const setSocketResponse = useSupportRequestStore((state) => state.setSocketResponse);
  const clearStore = useSupportRequestStore((state) => state.clearStore);

  useEffect(() => {
    setId(supportRequestId);
    socket.emit('support-requests-socket', userId);
    console.log('emit: support-requests-socket ', userId);
    // setSocketResponse({
    //   agent: mockSupportRequests.slice(0, 5),
    //   unassigned: mockSupportRequests.slice(5, 10),
    //   subscribed: [],
    //   helpRequested: [],
    //   notifications: [],
    // });
    const socketCallback = (data: SupportRequestSocketResponse) => {
      // console.log('Received requests: ', data);
      setSocketResponse(data);
    };
    socket.on('support-requests-socket', socketCallback);
    socketProvider.addToChannels('support-requests-socket', userId, socketCallback);
    const onDisconnectPendingSR = () => {
      console.log('Support request reset store');
      clearStore();
    };
    socketProvider.addToOnDisconnect('pendingSupportRequests', onDisconnectPendingSR);
    return () => {
      console.log('emit: disconnect SR socket');
      socketProvider.removeFromChannels('support-requests-socket');
      socket.emit('support-request-socket-disconnect', userId);
    };
  }, [userId]);

  //Mock
  // const myId = useGetAuthUser().currentUser?.uid;

  // setMyRequests(
  //   mockSupportRequests.filter((req) =>
  //     req.requests.some((req) => req._adminUserId == myId),
  //   ),
  // );
  // setOtherRequests(
  //   mockSupportRequests.filter((req) =>
  //     req.requests.some((req) => req._adminUserId != myId),
  //   ),
  // );
  // setSubscribedRequests(mockSupportRequests.slice(0, 4));

  return (
    <ScreenTwoPageLayout>
      <SupportRequestsList />
      {id ? (
        <SupportRequestItem
          originScreen="PendingSupportRequests"
          supportId={id}
          onClose={() => setId(undefined)}
        />
      ) : (
        <></>
      )}
    </ScreenTwoPageLayout>
  );
};

export default PendingSupportRequestsScreen;

const ScreenTwoPageLayout = ({ children }: { children: [JSX.Element, JSX.Element] }) => {
  return (
    <HStack
      flex={1}
      bg="monochrome-base"
      style={{ alignItems: 'flex-start', maxWidth: getScreenWidth() }}
    >
      <View style={{ height: '100%' }}>{children[0]}</View>
      <Divider vertical />
      <View flex={1} style={{ height: '100%', overflow: 'hidden' }} bg="monochrome-base">
        {children[1]}
      </View>
    </HStack>
  );
};
